import * as React from 'react'

import { commaStyleString } from '../../../../common/utils/formatString'

import * as styles from './pitLabel.module.css'

interface IProps {
  count: number
}

const PitLabel = ({ count }: IProps) => {
  return (
    <div className={styles.pitLabel}>
      <span className={styles.pitLabelCount}>
        {commaStyleString(count, ',')}
      </span>
    </div>
  )
}

export default PitLabel
